module.exports = __webpack_public_path__ + "static/media/windy.61a1b47b.png";